// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__8za11","info":"PatientInfo_info__2iF3U"};